module.exports = __webpack_public_path__ + "static/media/resume.7f7b9e42.pdf";